import { c as _c } from "react-compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@tanstack/react-query';
import Price from "../../price/Price";
import makeQueryKey from "../../../api/utils/make-query-key";
var ItemPriceBase = function ItemPriceBase(t0) {
  var $ = _c(5);
  var currency = t0.currency,
    fullPrice = t0.fullPrice,
    price = t0.price,
    employeePrice = t0.employeePrice,
    giftCardAmount = t0.giftCardAmount,
    isLoading = t0.isLoading;
  var t1;
  if ($[0] === Symbol["for"]("react.memo_cache_sentinel")) {
    t1 = {
      queryKey: makeQueryKey(["isSwooshUser"]),
      queryFn: window.webShellClient.identity.getIsSwooshUser
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  var _useQuery = useQuery(t1),
    isSwooshUser = _useQuery.data;
  if (isLoading) {
    return null;
  }
  if (!price && !fullPrice && !giftCardAmount) {
    return null;
  }
  var isDiscounted = price < fullPrice;
  var listPrice = isDiscounted ? fullPrice : price;
  var finalListPrice = listPrice || giftCardAmount;
  var discountedPrice;
  if (isDiscounted) {
    discountedPrice = isSwooshUser && employeePrice > 0 ? employeePrice : price || 0;
  }
  var t2;
  if ($[1] !== currency || $[2] !== discountedPrice || $[3] !== finalListPrice) {
    t2 = /*#__PURE__*/React.createElement(Price, {
      listPrice: finalListPrice,
      currency: currency,
      discountedPrice: discountedPrice
    });
    $[1] = currency;
    $[2] = discountedPrice;
    $[3] = finalListPrice;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
ItemPriceBase.propTypes = {
  currency: PropTypes.string.isRequired,
  fullPrice: PropTypes.number,
  price: PropTypes.number,
  employeePrice: PropTypes.number,
  giftCardAmount: PropTypes.number,
  isLoading: PropTypes.bool
};
export default ItemPriceBase;